<script setup lang="ts">
  import { watch } from 'vue';

  import { queryClient } from '~/queries';
  import { DocumentUser, MauResource } from '~/types';

  import WithAccountUser from './WithAccountUser.vue';
  import WithDocumentUser from './WithDocumentUser.vue';

  const { mdu, mau } = defineProps<{
    mdu?: DocumentUser;
    mau?: MauResource;
  }>();

  watch(
    () => mau,
    (newVal, oldVal) => {
      if (newVal?.account_uuid !== oldVal?.account_uuid) {
        queryClient.invalidateQueries();
      }
    }
  );
</script>

<template>
  <WithAccountUser v-if="mau">
    <slot />
  </WithAccountUser>
  <WithDocumentUser
    v-else-if="mdu"
    :mdu="mdu"
  >
    <slot />
  </WithDocumentUser>
  <slot v-else />
</template>
